import { render, staticRenderFns } from "./ChapuzonKids2026View.vue?vue&type=template&id=65775c87&"
import script from "./ChapuzonKids2026View.vue?vue&type=script&lang=ts&"
export * from "./ChapuzonKids2026View.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports